// src/app/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { environment } from "../environments/environment";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

export const firebaseApp = initializeApp(environment.firebaseConfig);

if (!environment.production && typeof window !== "undefined") {
  (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN =
    environment.recaptchaV3DebugKey;
}

export const appCheck = initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaV3Provider(environment.recaptchaV3SiteKey),
  isTokenAutoRefreshEnabled: true,
});

export const firebaseAuth = getAuth(firebaseApp);
export const firestoreDb = getFirestore(firebaseApp);
export const firebaseStorage = getStorage(firebaseApp);
